export default function Pot() {
    return (
        <svg  width="100%" height="100%" viewBox="0 0 999 847" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53.957 79.5C50.6861 52.4098 50.6063 34.4961 51.457 1L975.957 14.5C975.962 40.4613 974.755 54.6697 970.957 79.5H53.957Z" fill="#EF7A43" stroke="#EF7A43"/>
        <path d="M997.5 74L1 75.5C33.6996 349.112 70.8775 513.382 171 800C176.25 808.231 179.998 811.536 188.5 814.5C468.844 856.711 611.093 858.722 827 807.5C835.575 802.304 838.685 798.554 842.5 791C914.538 521.033 961.089 374.571 997.5 74Z" fill="#222E59" stroke="#222E59"/>
        </svg>
    )
}